import { useState, useEffect } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

const StudentAttendanceForm = () => {
  const [formData, setFormData] = useState({
    studentId: "",
    enrollmentDate: "",
    validity: "",
    dailyAttendance: [{ date: "", status: "Ab" }],
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const response = await fetch("/api/attendance/student", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    if (response.ok) {
      alert("Student attendance saved successfully!");
    } else {
      alert("Failed to save student attendance");
    }
  };

  return (
    <div className="p-6 max-w-xl mx-auto">
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <Label htmlFor="studentId">Student ID</Label>
          <Input
            type="text"
            name="studentId"
            value={formData.studentId}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <Label htmlFor="enrollmentDate">Enrollment Date</Label>
          <Input
            type="date"
            name="enrollmentDate"
            value={formData.enrollmentDate}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <Label htmlFor="validity">Validity</Label>
          <Input
            type="date"
            name="validity"
            value={formData.validity}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <Label htmlFor="dailyAttendance">Daily Attendance</Label>
          {/* Implement logic for dynamic daily attendance here */}
        </div>

        <div className="flex justify-end mt-4">
          <Button type="submit">Submit Attendance</Button>
        </div>
      </form>
    </div>
  );
};

export default StudentAttendanceForm;
